import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  socialWrap: {
    ...dFlex('space-around', 'center'),
    width: '100%',
  },
  icon: {
    ...dFlex('space-around', 'center'),
    borderRadius: '50%',
    border: `1px solid ${theme.primary.p2}`,
    height: 32,
    width: 32,
  },
}));

export default useStyles;
